module.exports = __webpack_public_path__ + "img/35ne.2b976b72.svg";